import LineFlightCreditIcon from 'LuxKit/Icons/line/LineFlightCreditIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import config from 'constants/config'
import { getTourCampaignTier, isTourCampaignActive } from 'constants/tours'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
  campaignTags?: Array<string>
}

function TourCampaignTravelTagLabel({ campaignTags, className }: Props) {
  const intl = useIntl()
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const isTourCampaignEnabled = isTourCampaignActive(region, config.BRAND)

  if (!isTourCampaignEnabled) {
    return null
  }

  const tier = getTourCampaignTier(campaignTags, intl)

  if (!tier) {
    return null
  }

  return <PromotionLabel className={className} variant="branded" icon={<LineFlightCreditIcon />}>{tier.tag}</PromotionLabel>
}

export default TourCampaignTravelTagLabel
